import { apiClient } from './client';

export interface AuditEntry {
  id: string;
  eventType: string;
  timestamp: string;
  buildingId: string;
  buildingName: string;
  actor: {
    id?: string;
    name?: string;
    apartment?: string;
  } | null;
  target: {
    spotNumber?: string;
    levelLabel?: string;
  } | null;
  metadata: Record<string, unknown>;
}

export interface CursorPaginationResponse<T> {
  data: T[];
  pagination: {
    nextCursor: string | null;
    hasMore: boolean;
  };
}

export const adminAPI = {
  getAuditLog: (filters?: Record<string, unknown>, limit = 50, cursor?: string) =>
    apiClient.get<CursorPaginationResponse<AuditEntry>>('/admin/audit', {
      params: { ...filters, limit, ...(cursor && { cursor }) },
    }),

  // Helper for fetching audit logs with pagination cursor
  async* getAuditLogPaginated(filters?: Record<string, unknown>, limit = 50) {
    let cursor: string | undefined;

    while (true) {
      const response = await adminAPI.getAuditLog(filters, limit, cursor);
      yield response.data.data;

      if (!response.data.pagination.hasMore) break;
      cursor = response.data.pagination.nextCursor ?? undefined;
    }
  },
};
